import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { UNZIPPEDFILES_COLLECTION, User } from '../type';

export const waitForHtmlContentUrl = (folderName: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        const documentPath = folderName.split("/").pop();
        const db = getFirestore();
        const docRef = doc(db, UNZIPPEDFILES_COLLECTION, documentPath ?? folderName);

        const unsubscribe = onSnapshot(docRef, (snap) => {
        if (snap.exists()) {
            const data = snap.data();
            const indexHtmlUrl = data.indexHtmlUrl;


            if (indexHtmlUrl) {
            unsubscribe(); // stop listening
            resolve(indexHtmlUrl); // ✅ return the index.html URL
            }
        }
        });

        // Optional timeout in case unzip fails
        setTimeout(() => {
        unsubscribe();
        reject(new Error("Unzipping timed out"));
        }, 60_000); // 60s
    });
};

export const sortedUsers = (users: User[]) => {
    return [...users].sort((a, b) => {
        return (a.displayName ?? '').localeCompare(b.displayName ?? '');
    });
}; 
